import React, { useEffect, useMemo } from "react";
import { Flex, Grid, Stack } from "@chakra-ui/react";
import { Page } from "../../components/Page";
import ActionList from "./components/NavItems/ActionList";
import RoundList from "./components/NavItems/RoundList";
import { useNavbar } from "../../components/Layout/Navbar/NavbarProvider";
import { useSyncAuditsWithSelectedRound, useSyncQuestionsWithSelectedRound } from "./QuestionnaireRound/RoundService";

// TODO 15% margin is fine on desktop (our main target), looks broken on mobile,
// and can also give bad layout on smaller screens, with tables that are forced to use scrollbars
// Possible improvement: reduce the minimum margin, and have a couple of options for content pages:
// 1. use a fixed width, for a readable column of text
// 2. use the full width available, for large tables and other wide content
/**
 * Adds the top navbar
 */
const IssbContainer = ({ margin = "15%", children, spacing = 10 }) => {
  const { setNavbarContent } = useNavbar();

  useSyncQuestionsWithSelectedRound();
  useSyncAuditsWithSelectedRound();

  // TODO this means new rounds won't be available until the page is reloaded
  const navbarContent = useMemo(
    () => (
      <Flex gap={2}>
        <ActionList />
        <RoundList />
      </Flex>
    ),
    []
  );

  useEffect(() => {
    setNavbarContent(navbarContent);

    return () => setNavbarContent(null);
  }, [navbarContent, setNavbarContent]);

  return (
    <Grid
      id="issb-container"
      templateColumns="1fr"
      // templateColumns="1fr 350px"
      gap={0}
      position="relative"
      // overflow="scroll"
      width="100%"
      bg="pureWhite"
    >
      <Page>
        <Stack spacing={spacing} p={4} bg="pureWhite" marginLeft={margin} marginRight={margin}>
          {children}
        </Stack>
      </Page>
    </Grid>
  );
};

export default IssbContainer;
